var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDzikirIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96959 10.9956C6.44892 10.9956 7.64816 9.79633 7.64816 8.317C7.64816 6.83767 6.44892 5.63843 4.96959 5.63843C3.49025 5.63843 2.29102 6.83767 2.29102 8.317C2.29102 9.79633 3.49025 10.9956 4.96959 10.9956Z",
    fill: "url(#paint0_linear_493_646)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71945 5.10271C9.60705 5.10271 10.3266 4.38317 10.3266 3.49557C10.3266 2.60797 9.60705 1.88843 8.71945 1.88843C7.83185 1.88843 7.1123 2.60797 7.1123 3.49557C7.1123 4.38317 7.83185 5.10271 8.71945 5.10271Z",
    fill: "url(#paint1_linear_493_646)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9341 9.38843C9.86301 9.38843 8.18408 11.0674 8.18408 13.1384C8.18408 15.2095 9.86301 16.8884 11.9341 16.8884C14.0052 16.8884 15.6841 15.2095 15.6841 13.1384C15.6841 11.0674 14.0052 9.38843 11.9341 9.38843Z",
    fill: "url(#paint2_linear_493_646)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_493_646",
    x1: 1.90282,
    y1: 4.2639,
    x2: 6.29111,
    y2: 12.5288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_493_646",
    x1: 6.87939,
    y1: 1.06371,
    x2: 9.51236,
    y2: 6.02264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_493_646",
    x1: 7.6406,
    y1: 7.46409,
    x2: 13.7842,
    y2: 19.0349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8517"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDzikirIcon);
export default __webpack_public_path__ + "static/media/DzikirIcon.6150a12048ef9bede04fd1997e5ca270.svg";
export { ForwardRef as ReactComponent };